"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedBlockDataStore = void 0;
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var SavedBlockDataStore = (function () {
    function SavedBlockDataStore(user, permissionsService, rolesService, savedBlockApiService) {
        var _this = this;
        this.user = user;
        this.permissionsService = permissionsService;
        this.rolesService = rolesService;
        this.savedBlockApiService = savedBlockApiService;
        this.savedBlockList = [];
        this.isLoading = false;
        this.getSavedBlockById = function (id) {
            return _this.savedBlockList.find(function (block) { return block.id === id; });
        };
        this.getSavedBlockByIndex = function (index) {
            return _this.savedBlockList[index];
        };
        this.blockEditingLockedToAdmins = function (id) {
            var _a;
            return (_a = _this.savedBlockList.find(function (block) { return block.id === id; })) === null || _a === void 0 ? void 0 : _a.$editingLockedToAdmins;
        };
        this.deleteById = function (id) {
            (0, lodash_1.remove)(_this.savedBlockList, { id: id });
        };
        this.add = function (savedBlock) {
            if (!savedBlock) {
                return;
            }
            savedBlock.$editingLockedToAdmins = false;
            savedBlock.$editable = true;
            _this.savedBlockList.push(savedBlock);
        };
        this.update = function (savedBlock) {
            var index = (0, lodash_1.findIndex)(_this.savedBlockList, { id: savedBlock.id });
            if (index < 0) {
                return { isNameChanged: false };
            }
            var isNameChanged = _this.savedBlockList[index].savedBlockName !== savedBlock.savedBlockName;
            _this.savedBlockList[index] = savedBlock;
            return { isNameChanged: isNameChanged };
        };
        this.setLockEditingSetting = function (id, newState) {
            var savedBlock = _this.savedBlockList.find(function (block) { return block.id === id; });
            if (savedBlock) {
                savedBlock.$editingLockedToAdmins = newState;
                savedBlock.$editable = _this.rolesService.isAdmin(_this.user) || !newState;
            }
        };
        this.recordUsage = function (id, lastUsedAt) {
            if (!id || !lastUsedAt) {
                return;
            }
            var savedBlock = _this.savedBlockList.find(function (block) { return block.id === id; });
            if (savedBlock) {
                savedBlock.lastUsedAt = lastUsedAt;
            }
        };
        this.setBlocksPermissions = function (blocks) {
            var e_1, _a;
            var isAdmin = _this.rolesService.isAdmin(_this.user);
            try {
                for (var blocks_1 = __values(blocks), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()) {
                    var block = blocks_1_1.value;
                    block.$editingLockedToAdmins = _this.permissionsService.isBlockEditableOnlyByAdmins(block);
                    block.$editable = isAdmin || !block.$editingLockedToAdmins;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (blocks_1_1 && !blocks_1_1.done && (_a = blocks_1.return)) _a.call(blocks_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
    }
    SavedBlockDataStore.prototype.fetchSavedBlocksByFolderId = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var blocks;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.savedBlockList.some(function (block) {
                            return block.parentFolder === id || (id === DashboardTypes_1.SavedBlockCollection.All && !block.parentFolder);
                        })) {
                            return [2];
                        }
                        this.isLoading = true;
                        return [4, this.savedBlockApiService.getSavedBlocksByFolderId(id)];
                    case 1:
                        blocks = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.isLoading = false;
                        });
                        if (blocks.length === 0) {
                            return [2];
                        }
                        this.setBlocksPermissions(blocks);
                        this.savedBlockList = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(this.savedBlockList), false), __read(blocks), false), "id");
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(SavedBlockDataStore.prototype, "savedBlocks", {
        get: function () {
            return this.savedBlockList;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SavedBlockDataStore.prototype, "savedBlockList", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SavedBlockDataStore.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], SavedBlockDataStore.prototype, "fetchSavedBlocksByFolderId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], SavedBlockDataStore.prototype, "savedBlocks", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDataStore.prototype, "deleteById", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDataStore.prototype, "add", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDataStore.prototype, "update", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDataStore.prototype, "setLockEditingSetting", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDataStore.prototype, "recordUsage", void 0);
    return SavedBlockDataStore;
}());
exports.SavedBlockDataStore = SavedBlockDataStore;
